// TODO: import logic from shared folder so it's not defined twice

import { Product } from "../graphql/operations";

export const hasPrivateGroups = (product: Product) =>
  !!product.privatePrices.find(({ price }) => price !== null);

export const getMinPrivateGroup = (product: Product) =>
  product.privatePrices[0]?.minGroupSize;

export const getMaxPrivateGroup = (product: Product) => {
  const lastPrivatePrice =
    product.privatePrices[product.privatePrices.length - 1];
  if (!lastPrivatePrice) return undefined;
  return lastPrivatePrice.price === null
    ? lastPrivatePrice.minGroupSize - 1
    : product.maximumInGroup;
};
export const getPrivateGroup = (product: Product, groupSize: number) =>
  product.privatePrices.find(({ price, minGroupSize }, index) => {
    const maxGroupSize =
      (product.privatePrices[index + 1]?.minGroupSize ??
        product.maximumInGroup + 1) - 1;
    return (
      groupSize >= minGroupSize && groupSize <= maxGroupSize && price !== null
    );
  });

export const getPrivateGroupPrice = (
  product: Product,
  groupSize: number,
  isPrivate?: boolean
) =>
  isPrivate ?? true
    ? getPrivateGroup(product, groupSize)?.price ?? undefined
    : undefined;

export const getPrivateGroupSize = (bookingDetails: Detail[]) => {
  return bookingDetails
    .filter((detail) =>
      detail.productPrice
        ? !detail.productPrice.excludeFromPrivateGroupCount
        : !detail.excludeFromPrivateGroupCount
    )
    .reduce((sum, detail) => sum + detail.quantity, 0);
};

type Detail = {
  quantity: number;
  excludeFromPrivateGroupCount?: boolean;
  productPrice?: {
    excludeFromPrivateGroupCount?: boolean;
  };
};
